<script setup>
import { reactive } from 'vue';

// declare vars
const state = reactive({
  patient: null,
})
const props = defineProps(['patient']);
const emits = defineEmits(['editPatient']);

// main script
state.patient = props.patient;

// declare functions
/**
 * Returns the string to display indicating
 * whether the patient has a disease or not
 */
 function diseaseText(){
  if(state.patient.diseases.length) return 'Yes';
  else return 'No';
}

function editPatient(){
  emits('editPatient');
}

</script>
<template>
  <div class="wrapper">
    <div class="title">
      <h1>Patient Info</h1>
    </div>
    <div class="content-box">

      <div class="prop-container">
        <div class="prop">
          <div class="prop-name">Name:</div>
          <div class="prop-value">{{ state.patient.name }}</div>
        </div>
        <div class="prop">
          <div class="prop-name">Date of Birth:</div>
          <div class="prop-value">{{ state.patient.dateOfBirth }}</div>
        </div>
        <div class="prop">
          <div class="prop-name">Patient has comorbidity:</div>
          <div class="prop-value">{{ diseaseText() }}</div>
        </div>
      </div>
      <button id="edit-patient" @click="editPatient()">Edit Patient</button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.wrapper {
  display: block;
}

.title {
  display: block;
  background-color: #fff;
  padding: 1.25rem;
  border-radius: 1rem;
  text-align: center;
  margin: 1rem 0;
  border: 1px solid #ccc;
  border-top: 5px solid #673ab7;
  // width: 22rem;

  h1 {
    display: inline;
  }
}

.content-box {
  width: 100%;
  height: 50%;
  text-align: center;
}

.prop-container {
  display: block;
  justify-content: space-between;
  align-items: center;

}

.prop {
  // display: block;
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-size: 1.2rem;
}

.prop-name {
  margin-right: 10px;
}

.prop-value {
  p {
    display: flex;
    justify-content: flex-end;
  }
  text-align: right;


  /* Add any styles for the prop-value here */
}
#edit-patient{
  margin: 1rem 0;
}
</style>